export const PROGRESS_BAR_SEND_REQUEST = [
  {
    name: 'Solicitud recibida',
    color: 'color-second-dark-blue',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Enviada',
    percent: '65',
    colorProgressBar: 'primary',
  },
  {
    name: 'Solicitud en revisión',
    color: 'color-black',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Revision',
    percent: '0',
    colorProgressBar: 'primary',
  },
  {
    name: 'Solicitud aprobada',
    color: 'color-dark-gray',
    iconUrl: '/assets/icono-status/aprove-status.svg',
    status: 'Aprobada',
    percent: '0',
    colorProgressBar: 'green',
  },
];

export const PROGRESS_BAR_REJECT_REQUEST = [
  {
    name: 'Solicitud enviada',
    color: 'color-black',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Enviada',
    percent: '0',
    colorProgressBar: 'green',
  },
  {
    name: 'Solicitud en revisión',
    color: 'color-black',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Revision',
    percent: '0',
    colorProgressBar: 'green',
  },
  {
    name: 'Rechazada',
    color: 'color-red',
    iconUrl: '/assets/icono-status/reject-status.svg',
    status: 'Rechazada',
    percent: '100',
    colorProgressBar: 'color-red',
  },
];

export const PROGRESS_BAR_CANCEL_REQUEST = [
  {
    name: 'Solicitud enviada',
    color: 'color-black',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Enviada',
    percent: '0',
    colorProgressBar: 'green',
  },
  {
    name: 'Solicitud aprobada',
    color: 'color-green',
    iconUrl: '/assets/icono-status/aprove-status.svg',
    status: 'Aprobada',
    percent: '50',
    colorProgressBar: 'color-green',
  },
  {
    name: 'Solicitud Anulada',
    color: 'color-black',
    iconUrl: '/assets/icon-summary/icon-anulada.svg',
    status: 'Anulada',
    percent: '100',
    colorProgressBar: 'color-black',
  },
];

export const PROGRESS_BAR_APROVE_REQUEST = [
  {
    name: 'Solicitud enviada',
    color: 'color-black',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Enviada',
    percent: '0',
    colorProgressBar: 'primary',
  },
  {
    name: 'Solicitud en revisión',
    color: 'color-black',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Revision',
    percent: '0',
    colorProgressBar: 'primary',
  },
  {
    name: 'Solicitud aprobada',
    color: 'color-green',
    iconUrl: '/assets/icono-status/aprove-status.svg',
    status: 'Aprobada',
    percent: '100',
    colorProgressBar: 'color-green',
  },
];

export const PROGRESS_BAR_ERROR_REQUEST = [
  {
    name: 'Solicitud enviada',
    color: 'color-black',
    iconUrl: '/assets/icono-status/send-status.svg',
    status: 'Enviada',
    percent: '0',
    colorProgressBar: 'primary',
  },
  {
    name: 'Solicitud con error',
    color: 'color-yellow',
    iconUrl: '/assets/icono-status/error-status.svg',
    status: 'Con error',
    percent: '60',
    colorProgressBar: 'color-yellow',
  },
  {
    name: 'Solicitud aprobada',
    color: 'color-green',
    iconUrl: '/assets/icono-status/aprove-status.svg',
    status: 'Aprobada',
    percent: '0',
    colorProgressBar: 'color-green',
  },
];

export const STATUS_REQUEST = {
  BENEFIT: 'Beneficio',
  COD_OPERATION: 'Código de operación',
  COL_ACTION: 'Acción',
  DATE: 'Fecha de adjudicación',
  STATUS: 'Estado',
  NAME: 'Nombres y Apellidos',
  RUT: 'RUT',
  BENEFICIARY: 'Beneficiario',
  DISCOUNT: 'Monto a Descontar',
  TYPEBONO: 'Tipo Movimiento'

};

export const COLOR_STATUS = {
  GREEN: 'copec-green',
  BLUE: 'copec-dark-blue-3',
  RED: 'copec-red',
  BLACK:'copec-black',
};

export const ELEMENTS_STATUS = [
  {
    value: 'Enviado',
    label: 'Enviada',
  },
  {
    value: 'Enviada',
    label: 'Enviada',
  },
  {
    value: 'Rechazada',
    label: 'Rechazada',
  },
  {
    value: 'Aprobada',
    label: 'Aprobada',
  },
  {
    value: 'Anulada',
    label: 'Anulada',
  },
];
